<template>
  <router-view id="app" />
</template>

<script>
  export default {
    name: 'Base',
  };
</script>
